import React from 'react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import type { LooselyLazyOptions } from '../index';
import { LoadingComponent } from '../loading-component';

export const Fallback = <TProps extends object>(options: LooselyLazyOptions<TProps>) => {
    let displayName = 'unknown';
    if ('loader' in options) {
        displayName = options.loader.displayName || 'unknown';
    }
    return !__SERVER__ ? (
        <UFOLoadHold name={displayName}>
            <LoadingComponent LoadingSkeleton={options.LoadingSkeleton} timeout={options.timeout} />
        </UFOLoadHold>
    ) : (
        <LoadingComponent LoadingSkeleton={options.LoadingSkeleton} timeout={options.timeout} />
    );
};
